import { ApiService } from "core/services";

class PostProcessingApi extends ApiService {
  constructor() {
    super("post-job-setting");
  }

  getAll(payload = null) {
    return this.get("", payload);
  }

  getById(id) {
    return this.get(`${id}`);
  }

  createPostJob(payload = null) {
    return this.post("empty", payload);
  }

  updatePostJob(id, payload = null) {
    return this.put(`${id}`, payload);
  }

  deletePostJob(id) {
    return this.delete(`${id}`);
  }
}

export default PostProcessingApi;
